<script>
    export default {
        name: "content-dialog-loading"
    }
</script>

<template>
    <div class="loading-dialog-container">
        <v-progress-circular
            :size="140"
            :width="7"
            color="primary"
            indeterminate
        />
    </div>
</template>

<style scoped>
    .loading-dialog-container {
        display: flex;
        justify-content: center;
        align-items: center;
        min-height: inherit;
    }
</style>
